import { Component, ComponentRef, OnInit, ViewContainerRef, input, viewChild } from '@angular/core';

import { FlexItem } from '../../../shared/services/product.service';
import { ComponentRegistry } from '../../components/component-lookup';

@Component({
  selector: 'app-flex-item',
  standalone: true,
  imports: [],
  template: '',
  styles: []
})
export class FlexComponent implements OnInit {
  content = viewChild.required('content', { read: ViewContainerRef });
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data = input<any>();
  tourId = input<string>();
  paywall = input<boolean>();
  paywallMessage = input<string | null>();
  children = input.required<FlexItem[]>();

  ngOnInit(): void {
    this.content().clear();
    this.children().forEach(child => {
      const component = ComponentRegistry.get(child.name);
      if (component) {
        const componentRef = this.content().createComponent(component);
        if (componentRef) {
          componentRef.setInput('tourId', child.tourId);
          Object.keys(child.data).forEach(key => {
            componentRef.setInput(key, child.data[key]);
          });
          if (child.children?.length > 0) {
            componentRef.setInput('children', child.children);
          }
          this.onChildCreated(child, componentRef);
        } else {
          console.error(`Failed to create component: ${child.name}`);
         }
      }
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
  protected onChildCreated(child: FlexItem, componentRef: ComponentRef<any>): void {}
}
